import { render, staticRenderFns } from "./video_list.vue?vue&type=template&id=08627322&scoped=true&"
import script from "./video_list.vue?vue&type=script&lang=js&"
export * from "./video_list.vue?vue&type=script&lang=js&"
import style0 from "./video_list.vue?vue&type=style&index=0&id=08627322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08627322",
  null
  
)

export default component.exports